import { Component, EventEmitter, OnInit } from '@angular/core';
import { ProjectOverviewStateService } from 'src/app/services/project-overview-state-service';
import { merge, of as observableOf, Subject } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { RequestService } from '../../../services/request.service';
import { ProductTypeCriteriumService } from 'src/app/services/product-type-criterium-service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
})
export class ProjectsComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  selectedOverview: string;
  selectedPendingView: string;
  countNew = 0;
  countInvoicing = 0;
  countDesign = 0;
  countSiteVisit = 0;
  countQuotation = 0;
  countPending = 0;
  reloadData = new EventEmitter<any>();
  pending: string;

  parentSubject: Subject<any> = new Subject();

  notifyChildren() {
    this.parentSubject.next('pending');
  }

  constructor(
    private projectOverviewStateService: ProjectOverviewStateService,
    private requestService: RequestService,
    private productTypeCriteriumService: ProductTypeCriteriumService
  ) {
    super();
  }

  ngOnInit() {
    this.selectedOverview = this.projectOverviewStateService.getSelectedView();
    this.selectedPendingView =
      this.projectOverviewStateService.getselectedPendingView();
    this.loadCounts();
    this.addSubscription(
      this.productTypeCriteriumService.getTypeCriteriumChangedSubscribable(),
      () => {
        this.loadCounts();
      }
    );
  }

  loadCounts() {
    this.countNew = 0;
    this.countInvoicing = 0;
    this.countDesign = 0;
    this.countSiteVisit = 0;
    this.countQuotation = 0;
    this.countPending = 0;
    this.getNewCount();
    this.getInvoiceCount();
    this.getDesignCount();
    this.getQuotationCount();
    this.getSiteVisitCount();
    this.getPendingCount();
  }

  changeSelectedView(value: string) {
    let previousValue = this.selectedOverview;
    this.selectedOverview = value;
    this.projectOverviewStateService.setSelectedView(value);
    if (value === 'pending' && previousValue === 'pending') {
      this.projectOverviewStateService.setselectedPendingView('');
    }
    this.notifyChildren();
  }

  getInvoiceCount() {
    merge(this.reloadData)
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.requestService.get(
            '/subprojects/status/Te_factureren/true', //TODO set correct endpoints
            this.productTypeCriteriumService.generateTypeCriteriumParam(),
            null,
            null,
            30,
            null,
            null
          );
        }),
        map((data) => {
          this.countInvoicing = Number.parseInt(
            data.headers.get('X-Total-Count')
          );
          return this.countInvoicing;
        }),
        catchError(() => {
          return observableOf(0);
        })
      )
      .subscribe((data) => {
        this.countInvoicing = data;
      });
  }

  getNewCount() {
    let status = ['Concept', 'Nieuw', 'Afhaling', 'Aanpassing', 'vv'];
    merge(this.reloadData)
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.requestService.get(
            '/subprojects/status/' + status + '/true', //TODO set correct endpoints
            this.productTypeCriteriumService.generateTypeCriteriumParam(),
            null,
            null,
            30,
            null,
            null
          );
        }),
        map((data) => {
          this.countNew = Number.parseInt(data.headers.get('X-Total-Count'));
          return this.countNew;
        }),
        catchError(() => {
          return observableOf(0);
        })
      )
      .subscribe((count) => {
        this.countNew = count;
      });
  }

  getDesignCount() {
    let status = ['Concept'];
    merge(this.reloadData)
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.requestService.get(
            '/subprojects/status/' + status + '/true', //TODO set correct endpoints
            this.productTypeCriteriumService.generateTypeCriteriumParam(),
            null,
            null,
            30,
            null,
            null
          );
        }),
        map((data) => {
          this.countDesign = Number.parseInt(data.headers.get('X-Total-Count'));
          return this.countDesign;
        }),
        catchError(() => {
          return observableOf(0);
        })
      )
      .subscribe((count) => {
        this.countDesign = count;
      });
  }

  getQuotationCount() {
    merge(this.reloadData)
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.requestService.get(
            '/subprojects/statusSubstatus/vv,Afhaling,Aanpassing,Concept,Nieuw,In_behandeling/Offerte/true', //TODO set correct endpoints
            this.productTypeCriteriumService.generateTypeCriteriumParam(),
            null,
            null,
            30,
            null,
            null
          );
        }),
        map((data) => {
          return Number.parseInt(data.headers.get('X-Total-Count'));
        }),
        catchError(() => {
          return observableOf(0);
        })
      )
      .subscribe((count) => {
        this.countQuotation = count;
      });
  }

  getSiteVisitCount() {
    merge(this.reloadData)
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.requestService.get(
            '/subprojects/statusSubstatus/vv,Afhaling,Aanpassing,Concept,In_behandeling/Werfbezoek/true',
            this.productTypeCriteriumService.generateTypeCriteriumParam(),
            null,
            null,
            30,
            null,
            null
          );
        }),
        map((data) => {
          this.countSiteVisit = Number.parseInt(
            data.headers.get('X-Total-Count')
          );
          return this.countSiteVisit;
        }),
        catchError(() => {
          return observableOf(0);
        })
      )
      .subscribe((count) => {
        this.countSiteVisit = count;
      });
  }

  getPendingCount() {
    let status = ['In_behandeling'];
    merge(this.reloadData)
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.requestService.get(
            '/subprojects/status/' + status + '/true',
            this.productTypeCriteriumService.generateTypeCriteriumParam(),
            null,
            null,
            30,
            null,
            null
          );
        }),
        map((data) => {
          this.countPending = Number.parseInt(
            data.headers.get('X-Total-Count')
          );
          return this.countPending;
        }),
        catchError(() => {
          return observableOf(0);
        })
      )
      .subscribe((count) => {
        this.countPending = count;
      });
  }

  getSelectButtonWidth(label: string) {
    switch (label) {
      case 'Nieuwe':
        return { 'width.px': 136.156 };
      case 'Offerte':
        return { 'width.px': 138 };
      case 'Werfbezoek':
        return { 'width.px': 170 };
      case 'In behandeling':
        return { 'width.px': 185 };
      case 'Te factureren':
        return { 'width.px': 175 };
    }
  }
}
